import React, { useState, useEffect } from "react";
import MainDashboardLayout from "../../../Layout/MainDashboardLayout";
import GRISidebar from "../../../Layout/GRISidebar";
import styles from "../../../styles/gri/general.module.css";
import {
  Box,
  Button,
  TextField,
  Typography,
  Alert,
  Snackbar,
} from "@mui/material";
import EastIcon from "@mui/icons-material/East";
import { put, api, get } from "../../../utils/api";
import { useNavigate, useParams } from "react-router-dom";
import ReviewBox from "../../../Components/Common/ReviewBox";
import { currentYear } from "../../../utils/generateYearRanges";
import CustomTextField from "../GRI300/GRI308/CustomTextField";
import SectionHeading from "../GRI300/GRI308/SectionHeading";

const Economic29 = ({hide}) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [disabled, setDisabled] = useState(false);
  const [errors, setErrors] = useState({});
  const [snackOpen, setSnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const [formData, setFormData] = useState({
    structureCommittees: "",
    listOfCommittes: "",
    bodyComposition: "",
  });
  const [griReview, setGriReview] = useState(() => JSON.parse(localStorage.getItem("griReview")));

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await get(
          `${api}/gri/get?type=GeneralDisclosures2021&Id=${id}`
        );
        const data =
          response.data.data.GeneralDisclosures2021
            ?.governanceStructureComposition || {};
        if (response?.data?.data?.year < currentYear - 1) setDisabled(true);
        setFormData({
          structureCommittees: data.structureCommittees || "",
          listOfCommittes: data.listOfCommittes || "",
          bodyComposition: data.bodyComposition || "",
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({ ...prev, [field]: value }));
    setErrors((prev) => ({ ...prev, [field]: "" }));
  };

  const validateForm = () => {
    let newErrors = {};
    let formIsValid = true;

    // Validate sector

    if (!formData.structureCommittees) {
      newErrors.structureCommittees = "This field is required";
      formIsValid = false;
    }

    if (!formData.listOfCommittes) {
      newErrors.listOfCommittes = "This field is required";
      formIsValid = false;
    }

    if (!formData.bodyComposition) {
      newErrors.bodyComposition = "This field is required";
      formIsValid = false;
    }

    setErrors(newErrors);
    return formIsValid;
  };

  const handleSubmit = async () => {
    if (!disabled) {
      if (!validateForm()) return; // Validate form before submission
      const payload = {
        type: "GeneralDisclosures2021",
        governanceStructureComposition: {
          ...formData,
        },
        submitted2_9: true,
      };

      try {
        const token = sessionStorage.getItem("token");
        if (!token) {
          throw new Error("Authentication token is missing.");
        }
        await put(`${api}/gri/update?Id=${id}`, payload);
        navigate(`/gri/general-disclosure/2-10/${id}`);
      } catch (error) {
        console.error("Error updating data:", error);
        setSnackOpen({
          open: true,
          message: "Error updating data. Please try again.",
          severity: "error",
        });
      }
    } else {
      navigate(`/gri/general-disclosure/2-10/${id}`);
    }
  };

  const renderContent = ({ hide }) => (
      <>
      {/* <SectionHeading text="2-1 Activities, value chain and other business relationships" /> */}
      <p className={styles.main_heading} >
        2-9 Governance structure and composition
      </p>
      <Box sx={{ display: "flex", flexDirection: "column" }}>
        {/* Section A */}
        <SectionHeading text="a. Describe the organization's governance structure, including committees of the highest governance body."  sx={{ marginTop: hide ? "-1rem" : "0rem"}}/>
        <CustomTextField
          value={formData.structureCommittees}
          onChange={(e) =>
            handleInputChange("structureCommittees", e.target.value)
          }
          error={errors.structureCommittees}
          helperText={errors.structureCommittees}
          disabled={disabled}
        />

        {/* Section B */}
        <SectionHeading text="b. Provide a list of the committees within the highest governance body responsible for making decisions and overseeing the organization's impact on the economy, environment, and people." />
        <CustomTextField
          value={formData.listOfCommittes}
          onChange={(e) => handleInputChange("listOfCommittes", e.target.value)}
          error={errors.listOfCommittes}
          helperText={errors.listOfCommittes}
          disabled={disabled}
        />

        {/* Section C */}
        <SectionHeading
          text="c. Describe the composition of the highest governance body and its committees by executive and non-executive members,
       independence, tenure of members on the governance body, number of other significant positions and commitments held by each member, and the
        nature of the commitments, gender, under-represented social groups, competencies relevant to the impacts of the organization, stakeholder representation."
        />
        <CustomTextField
          value={formData.bodyComposition}
          onChange={(e) => handleInputChange("bodyComposition", e.target.value)}
          error={errors.bodyComposition}
          helperText={errors.bodyComposition}
          disabled={disabled}
        />

        {/* Submit Button */}
        

        {/* Snackbar for success/error messages */}
        <Snackbar
          open={snackOpen.open}
          message={snackOpen.message}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "top", horizontal: "center" }}
          onClose={() => setSnackOpen({ ...snackOpen, open: false })}
        >
          <Alert
            severity={snackOpen.severity}
            variant="filled"
            sx={{ width: "100%" }}
          >
            {snackOpen.message}
          </Alert>
        </Snackbar>
      </Box>
    </>
  )

  return (
    <>
          {!hide ? (
            <MainDashboardLayout sidebar={<GRISidebar />}>
              {renderContent({ hide })}
    
              <>
                {!griReview ? (
          <Box sx={{ ml: "1rem", width: "98%" }}>
            <ReviewBox url={"/gri"} handleSubmit={handleSubmit} />
          </Box>
        ) : (
          <Box textAlign="right" sx={{ mt: 3 }}>
            <Button
              variant="contained"
              sx={{ bgcolor: "#1C486B", textTransform: "none", mt: 3, mb: 5 }}
              onClick={handleSubmit}
            >
              Save & Continue <EastIcon sx={{ ml: 2 }} />
            </Button>
          </Box>
        )}
              </>
            </MainDashboardLayout>
          ) : (
            renderContent({ hide })
          )}
        </>
  
  );
};

export default Economic29;
